import React from "react";
import { Image, Col } from "react-bootstrap";
import "../styles/counter.css";
import Icono from "../img/icoinstagram.svg";
import Icono2 from "../img/icofacebook.svg";
import Icono3 from '../img/icolinkedin.svg';
// import Icono4 from '../img/icotiktok.svg';

const CounterModerm = () => {
  return (
    <Col className="hero">
      <div className="social-links">
        <a id="facebook" href="https://www.facebook.com/nicolas.m.salcedo.9">
          <Image src={Icono2} alt="facebook" />
        </a>
        <a href="https://www.instagram.com/nickmuoz/">
          <Image src={Icono} alt="instagram" />
        </a>
        <a href="https://www.linkedin.com/in/nicolas-munoz-salcedo/">
            <Image src={Icono3} alt="linkedin" />
          </a>
          {/* <a href="https://vm.tiktok.com/ZM2KUfHuN/">
            <Image src={Icono4} alt="tiktok" />
          </a> */}
      </div>
      <br />
      <span>
        Developed By <a href="https://wa.me/573015442800">@nicolasmuoz 2023</a>
      </span>
    </Col>
  );
};

export default CounterModerm;
